/**
 * Chaves do cache da conversa aberta. Todas ficam FORA da chave da sessão, então o logout e a troca
 * de conta as descartam junto com o resto (`purgeUserData`). A T26 (tempo real) atualiza estes
 * mesmos caches com eventos do WebSocket: não mude os formatos.
 */
export const conversationKey = (id: string) => ['conversation', id] as const;
/** `InfiniteData<MessageListResponse, string | null>`: a página 0 é a mais recente. */
export const messagesKey = (id: string) => ['messages', id] as const;
/** `Note[]`, da mais antiga para a mais nova. */
export const notesKey = (id: string) => ['notes', id] as const;
/** Todos os usuários (só administrador): destinos de transferência. */
export const usersKey = ['users'] as const;
/** Números de WhatsApp ligados (`GET /lines`): em que número cada conversa acontece. */
export const linesKey = ['lines'] as const;
/**
 * Última recusa `409 reply_window_closed` do servidor nesta conversa (`WindowRefusal | null`): vive
 * no cache porque quem a recebe (o envio, o reenvio) está fora da árvore do React e quem a mostra
 * (o aviso do chat, o painel) está dentro dela.
 */
export const replyWindowRefusalKey = (id: string) => ['reply-window', 'refusal', id] as const;
/** `ConversationBitrix`: o Lead da conversa no Bitrix (ou o motivo de não haver). */
export const conversationBitrixKey = (id: string) => ['bitrix', 'conversation', id] as const;
